import type { RatingSummaryResponse } from "@nlc/shared-types";

import { Star } from "lucide-react";
import { twMerge } from "tailwind-merge";

import { STAR_FILL_CLASSES } from "@/components/star-rating";

interface SummaryCardsProps {
  summary?: RatingSummaryResponse;
}

export function SummaryCards({ summary }: SummaryCardsProps) {
  const average =
    summary?.averageOverall == null ? "—" : summary.averageOverall.toFixed(1);
  const count = summary?.reviewsSubmitted ?? 0;

  return (
    <div className="flex flex-col gap-md sm:flex-row">
      <Card subtitle="across all your requests" title="Your rating,">
        <span className="text-2xl font-semibold text-text-primary">
          {average}
        </span>
        {average !== "—" && (
          <Star className={twMerge("size-5", STAR_FILL_CLASSES)} />
        )}
      </Card>
      <Card
        subtitle="Keep it up! your feedback shapes your experience"
        title="Reviews submitted,"
      >
        <span className="text-2xl font-semibold text-text-primary">
          {count}
        </span>
      </Card>
    </div>
  );
}

function Card({
  children,
  subtitle,
  title,
}: {
  children: React.ReactNode;
  subtitle: string;
  title: string;
}) {
  return (
    <div className="flex flex-1 items-center justify-between gap-md rounded-lg bg-bg-secondary px-lg py-md">
      <p className="text-xs text-text-tertiary">
        <span className="font-medium text-text-secondary">{title}</span>{" "}
        {subtitle}
      </p>
      <div className="flex shrink-0 items-center gap-xs">{children}</div>
    </div>
  );
}
